"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProfileView = ProfileView;
var _litHtml = require("lit-html");
var _solidLogic = require("solid-logic");
require("./styles/ProfileView.css");
var _QRCodeCard = require("./QRCodeCard");
var _ProfileViewModelPresenter = require("./ProfileViewModelPresenter");
var _ContactInfoSection = require("./sections/contactInfo/ContactInfoSection");
var _LanguageSection = require("./sections/languages/LanguageSection");
var _SkillsSection = require("./sections/skills/SkillsSection");
var _ResumeSection = require("./sections/resume/ResumeSection");
var _ProjectSection = require("./sections/projects/ProjectSection");
var _HeadingSection = require("./sections/heading/HeadingSection");
var _BioSection = require("./sections/bio/BioSection");
var _SocialSection = require("./sections/social/SocialSection");
function getViewerMode(subject) {
  let mode = 'anonymous';
  if (_solidLogic.authn.currentUser() && _solidLogic.authn.currentUser().sameTerm(subject)) mode = 'owner';
  if (_solidLogic.authn.currentUser() && !_solidLogic.authn.currentUser().sameTerm(subject)) mode = 'authenticated';
  return mode;
}
function renderSidebar(store, subject, accounts, skills, languages, contactInfo, viewerMode, onSaved) {
  return (0, _litHtml.html)`
    <aside 
      aria-labelledby="sidebar-heading" 
      class="profile__sidebar p-sm" 
    >
      <h2 id="sidebar-heading" class="sr-only">Sidebar</h2>
      <div aria-label="Sidebar Content" class="flex-column gap-md">
        ${(0, _SocialSection.renderSocialAccounts)(store, subject, accounts, viewerMode, onSaved)}
        ${(0, _SkillsSection.renderSkillsSection)(store, subject, skills, viewerMode, onSaved)}
        ${(0, _LanguageSection.renderLanguageSection)(store, subject, languages, viewerMode, onSaved)}
        ${(0, _ContactInfoSection.renderContactInfoSection)(store, subject, contactInfo, viewerMode, onSaved)}
        ${renderQRCode(subject, store)}
      </div>
    </aside>
  `;
}
function renderQRCode(subject, store) {
  return (0, _litHtml.html)`
      <section class="profile__section border-lighter profile__qr-code" aria-labelledby="qr-heading" tabindex="-1">
        <h2 id="qr-heading" class="sr-only">QR code</h2>
        <div class="qrcode-card__frame flex-center">
          ${(0, _QRCodeCard.QRCodeCard)(subject, store)}
        </div>
      </section>
  `;
}
async function ProfileView(subject, context, onSaved) {
  const store = context.session.store;
  const viewerMode = getViewerMode(subject);
  const viewModel = await (0, _ProfileViewModelPresenter.presentProfileViewModel)(subject, store);
  const profileDetails = viewModel.profileDetails;
  const rolesByType = viewModel.cvDetails;
  const skills = viewModel.skills;
  const languages = viewModel.languages;
  const projects = viewModel.projects;
  const bioDetails = viewModel.bioDetails;
  const accounts = viewModel.social;
  const contactInfo = viewModel.contactInfo;
  return (0, _litHtml.html)` 
    <div class="profile-pane-root">
      <main
        id="main-content"
        class="profile-grid"
        tabindex="-1"
      > 
        <h1 id="profile-content-heading" class="sr-only">Profile for ${profileDetails.name}</h1>

        <section
          class="profile__main flex-column gap-md p-sm"
          >
          <h2 id="profile-main-heading" class="sr-only">Main Profile Content</h2>

          ${(0, _HeadingSection.renderHeadingSection)(context, subject, profileDetails, viewerMode, onSaved)}
          ${(0, _BioSection.renderBioSection)(store, subject, bioDetails, viewerMode, onSaved)}
          ${(0, _ResumeSection.renderCVSection)(store, subject, rolesByType, viewerMode, onSaved)}
          ${(0, _ProjectSection.renderProjectSection)(store, subject, projects, viewerMode, onSaved)}
          
        </section>
        ${renderSidebar(store, subject, accounts, skills, languages, contactInfo, viewerMode, onSaved)}
      </main>
    </div>
  `;
}